'use client'

import React from 'react'
import { trackClickDirections, trackViewPark, trackSuggestParkClick } from '../lib/analytics'

export function DirectionsLink({ href, citySlug, parkSlug, children }) {
  const handleClick = () => {
    trackClickDirections(citySlug, parkSlug)
  }

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
      className="btn-cta"
    >
      {children}
    </a>
  )
}

export function ParkDetailTracker({ citySlug, parkSlug, children }) {
  // Track park detail view on mount
  React.useEffect(() => {
    trackViewPark(citySlug, parkSlug)
  }, [citySlug, parkSlug])

  return children
}

export function SuggestParkButton({ citySlug, href, children }) {
  const handleClick = () => {
    trackSuggestParkClick(citySlug)
  }

  return (
    <a
      href={href}
      onClick={handleClick}
      style={{ textDecoration: 'none', color: 'inherit' }}
    >
      {children}
    </a>
  )
}
